import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
export function HeroSection() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const timeString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <>
      <div className="fixed top-0 left-0 w-full bg-red-600 text-white text-center py-2 z-50 font-bold shadow-md text-sm md:text-base" data-id="element-98">
        {timeLeft > 0 ? <p data-id="element-99">⏳ OFERTA EXPIRA EN: {timeString} | 🔥 CUPOS LIMITADOS</p> : <p data-id="element-100">OFERTA EXPIRADA | 🔥 CUPOS LIMITADOS</p>}
      </div>

      <section className="pt-16 pb-8 px-4 bg-white flex flex-col items-center text-center" data-id="element-101">
        <div className="max-w-3xl mx-auto w-full" data-id="element-102">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-103">
            <p className="text-base md:text-lg font-semibold text-gray-700 mb-2" data-id="element-104">
              🥗 Para personas que quieren bajar de peso sin dietas extremas
            </p>

            <h1 className="text-5xl md:text-7xl font-extrabold text-gray-900 mb-4 leading-tight tracking-tight" data-id="element-105">
              Adelgaza con <span className="text-red-600" data-id="element-106">Airfryer</span>
            </h1>

            <a href="#compra" className="block cursor-pointer mb-5 transform hover:scale-105 transition-transform duration-300" data-id="element-107">
              <img src="https://cdn.magicpatterns.com/uploads/8Cn4f9jqDojaotAEHzq35y/Mockup.png" alt="Adelgaza con Airfryer MegaPack" className="w-full max-w-xl mx-auto drop-shadow-2xl rounded-xl" data-id="element-108" />
            </a>

            <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-109">
              El método práctico para bajar de peso comiendo delicioso, rápido y
              sin dietas extremas
            </h2>

            <div className="bg-yellow-100 border-2 border-yellow-400 rounded-lg p-3 mb-4 inline-block shadow-sm" data-id="element-110">
              <p className="font-bold text-base md:text-lg text-yellow-800" data-id="element-111">
                📦 MEGAPACK COMPLETO — Incluye 6 tomos + 3 bonos exclusivos
              </p>
            </div>

            <p className="text-base md:text-lg text-gray-600 mb-5 leading-relaxed" data-id="element-112">
              Más de 50 recetas saludables, planificación semanal, listas de
              compras y sistema completo para adelgazar sin dejar de disfrutar
              la comida.
            </p>

            <div className="flex flex-wrap justify-center items-center gap-3 md:gap-5 mb-5 font-semibold text-gray-700 text-base" data-id="element-113">
              <span className="flex items-center" data-id="element-114">
                <span className="text-green-500 mr-1" data-id="element-115">✔</span> recetas fáciles
              </span>
              <span className="flex items-center" data-id="element-116">
                <span className="text-green-500 mr-1" data-id="element-117">✔</span> ingredientes
                económicos
              </span>
              <span className="flex items-center" data-id="element-118">
                <span className="text-green-500 mr-1" data-id="element-119">✔</span> listo en minutos
              </span>
              <span className="flex items-center" data-id="element-120">
                <span className="text-green-500 mr-1" data-id="element-121">✔</span> ideal para
                principiantes
              </span>
            </div>

            <p className="text-lg font-bold text-gray-800 mb-5" data-id="element-122">
              Empieza hoy mismo a transformar tu forma de cocinar y de
              alimentarte.
            </p>

            <CTAButton href="#compra" text="👉 QUIERO EL MEGAPACK" data-id="element-123" />

            <div className="mt-5 p-3 bg-gray-50 rounded-lg border border-gray-200 inline-block max-w-md" data-id="element-124">
              <p className="font-bold text-gray-900 mb-1 text-sm" data-id="element-125">
                🛡️ Garantía de satisfacción de 7 días
              </p>
              <p className="text-xs text-gray-600" data-id="element-126">
                Si el método no te ayuda a organizar tu alimentación y cocinar
                más saludable, puedes solicitar la devolución del dinero.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}